export * from './lib/ui-confirm.component';
